<script>
    import AdminCard from "../ui/AdminCard.svelte";
    import {push, replace} from "svelte-spa-router";
    import {getEntitiesAdmin, getSchemas} from "../../../api-client";
    import AddButton from "../ui/AddButton.svelte";
    import {findTranslation} from "../util/findMissingTranslation";
    import AuthGuard from "../../../common/AuthGuard.svelte";

    export let params = {};
    $: schemaName = params.schemaName;
    $: schema = getSchemas().then((data) =>
        data.find((s) => s.name === schemaName)
    );
    $: displayName = schema.displayName;
    $: entities = getEntitiesAdmin(schemaName);

    function logout() {
        window.localStorage.removeItem("token");
        window.localStorage.removeItem("userId")
        push("/login");
    }
</script>

<AuthGuard/>

<div style="height:100%; display: flex;">
    <div
            style="display: flex; flex-direction: column; background: var(--black-100); color: white; padding: 24px; justify-content: space-between; height: auto;"
    >
        <div style="display: flex; flex-direction: column;">
            {#await getSchemas() then schemas}
                {#each schemas as schema}
                    <div
                            on:click={() =>
                            replace("/admin/entities/" + schema.name)}
                            style="cursor: pointer"
                            class:selected={schema.name === schemaName}
                    >
                        {schema.displayName}
                    </div>
                {/each}
            {/await}
        </div>

        <div style="display: flex; flex-direction: column;">
            <div
                    on:click={() => push("/admin/settings")}
                    style="cursor: pointer;"
            >
                Einstellungen
            </div>
            <div
                    class="divider-h"
                    style="background-color: var(--white-100); margin: 16px 0;"
            />
            <div on:click={logout} style="cursor: pointer;">Logout</div>
        </div>
    </div>

    <div class="admin-overview-page__wrapper">
        <div
                style="display: grid; grid-template-columns: 220px 220px 220px; grid-auto-rows: 280px; grid-gap: 16px; margin-bottom: 24px"
        >
            {#await schema then schema}
                {#await entities then entities}
                    {#each entities as entity}
                        <!-- {#if entity[schema.nameProperty]} -->
                        <AdminCard
                                title={findTranslation(entity, schema.nameProperty)}
                                {schema}
                                {entity}
                                on:click={() =>
                                push(
                                    `/admin/entities/${schemaName}/${entity.id}`
                                )}
                        />
                        <!-- {/if} -->
                    {/each}
                {:catch error}
                    <div>Es ist ein Fehler aufgetreten</div>
                {/await}
            {/await}
        </div>
        <AddButton
                on:click={() => push("/admin/entities/" + schemaName + "/add")}
                schemaName={displayName}
        />
    </div>
</div>

<style>
    .admin-overview-page__wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: auto;
        overflow: auto;
    }

    .selected {
        color: var(--white-64);
        /* font-weight: bold; */
    }
</style>
